<div *ngIf="payment()">
  <div>
    <h2 class="page-details-title-style">Traveler Payment {{ payment()?.id }}</h2>
  </div>

  <mat-tab-group dynamicHeight>
    <mat-tab label="General Info">
      <div class="filter__fields">
        <mat-card class="mat-elevation-z8">
          <mat-card-content>
            <mat-grid-list [cols]="2" gutterSize="10px" rowHeight="90">
              <mat-grid-tile>
                <read-only-form-field title="Payment ID" [value]="payment()?.id?.toString()" testId="kt-payment-id" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Trip Reference" [value]="payment()?.tripReference" testId="kt-payment-trip-ref" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Traveler" [value]="payment()?.travelerName" testId="kt-payment-traveler" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Product Type" [value]="payment()?.productTypeName" testId="kt-payment-product-type" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Invoice Type" [value]="payment()?.invoiceTypeName" testId="kt-payment-invoice-type" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Amount" [value]="payment()?.amount?.toString()" testId="kt-payment-amount" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Source Amount" [value]="payment()?.sourceAmount?.toString()" testId="kt-payment-source-amount" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Amount USD" [value]="payment()?.amountUSD?.toString()" testId="kt-payment-amount-usd" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Currency" [value]="payment()?.currencyCode" testId="kt-payment-currency" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Payment Date" [value]="payment()?.paymentDate | date:'M/dd/yyyy'" testId="kt-payment-date" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Reference" [value]="payment()?.reference" testId="kt-payment-reference" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Vendor Reference" [value]="payment()?.vendorReference" testId="kt-payment-vendor-ref" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Payee Name" [value]="payment()?.payeeName" testId="kt-payment-payee" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Client Confirmation Code" [value]="payment()?.clientConfirmationCode" testId="kt-payment-confirmation" />
              </mat-grid-tile>
            </mat-grid-list>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>
    <mat-tab label="Payment Method">
      <div class="filter__fields">
        <mat-card class="mat-elevation-z8">
          <mat-card-content>
            <mat-grid-list [cols]="2" gutterSize="10px" rowHeight="90">
              <mat-grid-tile>
                <read-only-form-field title="CC Type" [value]="payment()?.creditCardType" testId="kt-payment-cc-type" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="CC Number" [value]="payment()?.creditCardNumber ? '****' + payment()?.creditCardNumber?.slice(-4) : ''" testId="kt-payment-cc-number" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Expiry Date" [value]="payment()?.expiryDate" testId="kt-payment-expiry" />
              </mat-grid-tile>
            </mat-grid-list>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
